import React from "react";
import { ItemBadges } from "@coworker/apprestructured/src/shared/components/item-cards/ItemBadges/ItemBadges";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";

interface ItemCardProps {
  children: React.ReactNode;
  badges?: ItemBadge[];
  className?: string;
  dataTestId?: string;
}

export const ItemCard = ({
  children,
  badges,
  className,
  dataTestId,
}: ItemCardProps) => {
  return (
    <div className={className} data-testid={dataTestId}>
      {badges && badges.length > 0 && (
        <ItemBadges data-testid={"item-badges"} badges={badges} />
      )}
      {children}
    </div>
  );
};
